import { showErrorMessage } from '@eltoro-ui/components'
import { V1ListOrgSubscriptionsResponse } from 'next-gen-sdk'
import { getApiUrl, toCamelCase } from '../Helpers'
import axios from 'axios'

export const listOrgSubscriptions = async (
  pageSize?: number,
  pageToken?: string,
  orgId?: string,
  orderBy?: string,
  id?: string,
  name?: string,
  pixelId?: string,
  pixelName?: string,
  tags?: Array<string>,
): Promise<V1ListOrgSubscriptionsResponse | undefined> => {
  const token = localStorage.getItem('eltoro_token')

  if (!token) return

  try {
    const url = `${getApiUrl()}/v1/subscriptions`

    // Build query parameters
    const params = new URLSearchParams()

    if (pageSize !== undefined) params.append('page_size', pageSize.toString())
    if (pageToken) params.append('page_token', pageToken)
    if (orgId) params.append('org_id', orgId)
    if (orderBy) params.append('order_by', orderBy)
    if (id) params.append('id', id)
    if (name) params.append('name', name)
    if (pixelId) params.append('pixel_id', pixelId)
    if (pixelName) params.append('pixel_name', pixelName)

    // Handle tags as multiple parameters
    if (tags && tags.length > 0) {
      tags.forEach((tag) => {
        if (tag.trim()) {
          params.append('tags', tag.trim())
        }
      })
    }

    const response = await axios.get(`${url}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    return toCamelCase(response.data) as V1ListOrgSubscriptionsResponse
  } catch (error) {
    showErrorMessage(
      'Error listing org subscriptions',
      (error as any)?.message || '',
    )
    throw error
  }
}
